import { get } from "lodash";
import { useMemo } from "react";
import { MdClose } from "react-icons/md";

const BeneficiaryChips = ({
  values,
  formProps,
  addBeneficiaries,
  setAddBeneficiaries,
  childrenNumber,
  setChildrenNumber,
  translation,
  onSubmit,
}) => {
  const childrenWithBirthDate = useMemo(
    () =>
      get(values, "children", []).filter((child) =>
        get(child, "identity.user.birthDate"),
      ),
    [values],
  );

  const spouseBirthDate = get(values, "spouse.identity.user.birthDate");

  const handleRemoveSpouse = () => {
    formProps.setFieldValue("spouse", undefined);
    setAddBeneficiaries((prev) => ({
      ...prev,
      spouse: false,
    }));
    onSubmit();
  };

  const handleRemoveChild = (index) => {
    const allChildren = get(values, "children", []);
    const childrenWithDates = allChildren.filter((child) =>
      get(child, "identity.user.birthDate"),
    );
    const childToRemove = childrenWithDates[index];

    const originalIndex = allChildren.findIndex(
      (child) => child === childToRemove,
    );

    if (originalIndex === -1) return;

    const updatedChildren = allChildren.filter((_, i) => i !== originalIndex);
    const newChildrenNumber = updatedChildren.length;

    setChildrenNumber(newChildrenNumber);
    if (newChildrenNumber === 0) {
      setAddBeneficiaries((prev) => ({
        ...prev,
        children: false,
      }));
    }
    formProps.setFieldValue("children", updatedChildren);
    onSubmit();
  };

  if (!addBeneficiaries.spouse && childrenWithBirthDate.length === 0) {
    return null;
  }

  return (
    <div className="beneficiary_chips">
      {addBeneficiaries.spouse && spouseBirthDate && (
        <div className="beneficiary_chips--button">
          <span>{translation.PRODUCTS.SPOUSE}</span>
          <MdClose size={20} onClick={handleRemoveSpouse} />
        </div>
      )}
      {childrenWithBirthDate.map((_, i) => (
        <div key={`child_${i}`} className="beneficiary_chips--button">
          <span>{`${translation.CHILDREN.CHILD.TITLE} ${i + 1}`}</span>
          <MdClose size={20} onClick={() => handleRemoveChild(i)} />
        </div>
      ))}
    </div>
  );
};

export default BeneficiaryChips;
